export default __webpack_public_path__ + "static/media/pcshield@3x.742ad371.png";